export default () => ({
  teams: {},
  currentPage: 0,
  pages: null
  // currentCampaign: null
})
